import { render, staticRenderFns } from "./AppImageView.vue?vue&type=template&id=50b2081d"
import script from "./AppImageView.vue?vue&type=script&lang=js"
export * from "./AppImageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports